// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItems_container__2SgSi","list":"MenuItems_list___kiEK","listItem":"MenuItems_listItem__2A6Tg"};